import type { PlayerVisitsRes } from '@on3/api';
import { Link } from 'components/Link';
import useAthlete from 'contexts/AthleteProvider';
import { useRouter } from 'next/router';

import styles from './VisitCenter.module.scss';
import { VisitCenterItems } from './VisitCenterItems';

export const VisitCenter = ({
  showAll,
  visitCenter,
}: {
  showAll?: boolean;
  visitCenter?: PlayerVisitsRes | null;
}) => {
  const { athlete } = useAthlete();
  const router = useRouter();
  const viewAllRoute = `/db/${router.query.id}/recruiting/${athlete?.recruitmentKey}/visit-center/`;
  const { visits = [], organizationCounts = [] } = visitCenter || {};

  const showViewAll = !showAll && (visits ?? []).length >= 5;

  return (
    <div className={styles.block}>
      <VisitCenterItems
        organizationCounts={organizationCounts}
        showAll={showAll}
        visits={visits}
      />
      {showViewAll && (
        <footer className={styles.footer}>
          <Link className={styles.viewAll} href={viewAllRoute}>
            View All
          </Link>
        </footer>
      )}
    </div>
  );
};
